import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { useNavigate, Link } from "react-router-dom";
import { auth, db } from "../utilities/firebaseConfig";

const ActiveJobs = () => {
  const navigate = useNavigate();
  const [activeJobs, setActiveJobs] = useState([]);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }

    // Reference to the "jobs" node in the database.
    const jobsRef = ref(db, "jobs");
    onValue(jobsRef, (snapshot) => {
      if (snapshot.exists()) {
        const jobsData = Object.entries(snapshot.val()).map(([id, job]) => ({
          id,
          ...job,
        }));
        // Filter jobs: only those posted by this user and with an active status.
        const filteredJobs = jobsData.filter(
          (job) =>
            job.userId === user.uid &&
            (job.status === "pending" || job.status === "assigned")
        );
        setActiveJobs(filteredJobs);
      } else {
        setActiveJobs([]);
      }
    });
  }, [navigate]);

  return (
    <div>
      <h2>Active Jobs</h2>
      {activeJobs.length > 0 ? (
        activeJobs.map((job) => (
          <div
            key={job.id}
            style={{
              border: "1px solid #ccc",
              margin: "10px",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <h4>{job.title}</h4>
            <p>
              <strong>Status:</strong> {job.status}
            </p>
            <Link to={`/job/${job.id}`}>View Details</Link>
          </div>
        ))
      ) : (
        <p>No active jobs found.</p>
      )}
      <br />
      <Link to="/dashboard">Back to Dashboard</Link>
    </div>
  );
};

export default ActiveJobs;
